import { Loader } from '@calm-web/design-system';

import GuideLayoutV1 from '@/components/app/guide/GuideLayout';
import GuideLayoutV2 from '@/components/app/guideV2/GuideLayout';
import { useAmplitudeExperiment } from '@/hooks/utils/experiments/useAmplitudeExperiment';
import { Guide } from '@/store/guide/types';
import { MeditationType, Program } from '@/store/program/types';
import { AmplitudeExperimentNames } from '@/utils/experiments/amplitudeExperiment';

type GuideLayoutProps = {
	guide: Guide | null;
	program: Program | null;
	rotateBackButton?: boolean;
};

const GuideLayout = ({ guide, program, rotateBackButton }: GuideLayoutProps) => {
	const { isEnrolled, isLoading } = useAmplitudeExperiment(AmplitudeExperimentNames.WEB_APP_REDESIGN_2);

	if (!guide || !program) {
		return null;
	}

	if (isLoading) {
		return <Loader />;
	}

	if (isEnrolled && program?.meditation_type !== MeditationType.Timer) {
		return <GuideLayoutV2 guide={guide} program={program} />;
	}

	return <GuideLayoutV1 guide={guide} program={program} rotateBackButton={rotateBackButton} />;
};

export default GuideLayout;
